module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAICAYAAADwdn+XAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABdSURBVHgBnZHLDcAgDEONMlIW6DRZo7BGpukC2alN1SIhQHx8ciK9d3EQkQjgxF4SmdnFzOE5DqwlqWokbxuSF/ZC/2dBkuFCMCkp4EowkFRwU9CRNOFhfOJv5m5u2yovCkw90cUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icn-dropdown-dark.png
// module id = /kAr
// module chunks = 0